import * as React from 'react';
import { TextArea } from "@progress/kendo-react-inputs";
import { GetTransactionData } from "./Transaction";
import configData from "../config.json";
import { GetToken } from '../components/Session';
import { Dialog, DialogActionsBar, Window } from "@progress/kendo-react-dialogs";
import { QRCode } from '@progress/kendo-react-barcodes';

export const QRPreview = (props) => {
    const trans = props.transaction;
    const site = props.site;
    const settings = props.settings;
    const [docket, setDocket] = React.useState(props.docket === undefined ? "" : "text:" + props.docket);

    if (trans !== undefined && site !== undefined && props.docket === undefined) {
        let o = { sites: null, customers: null, marks: null, sources: null, products: null, productCategories: null, users: null, vehicles: null, destinations: null, vehicleConfigurations: null };
        var td = GetTransactionData(trans, site.current, settings, true, o);
        const timeOffset = new Date().getTimezoneOffset() / 60;
        let init = {
            method: "POST",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken(), "Content-type": "application/json" },
            body: JSON.stringify(td)
        };
        let url = `${configData.SERVER_URL}apiv7/private/getdocketpreview?offset=${timeOffset}`;
        fetch(url, init).then(response => response.text()).then(d => {
            let dx = String(d).replaceAll(/\[\/?b\]/gi, "");
            setDocket(dx);
        });
    }
    

    const Close = () => {
        if (props.onClose) props.onClose();
    }

    const SaveReceipt = () => {
        if (props.onSave) props.onSave();
    }

    const Print = () => {
        if (props.onPrint) props.onPrint();
    }

    return (
        <Dialog title="Please scan your QR Receipt" onClose={Close}>
                <div className="row">
                    <QRCode value={docket} size="600px" />
                </div>
                <DialogActionsBar>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={Close}>Back</button>
                    {props.onSave && <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={SaveReceipt}>Save</button>}
                    {props.onPrint && <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={Print}>Print Docket</button>}
                </DialogActionsBar>
            </Dialog>
    );
}